import React from "react";
import { Sparkles } from "lucide-react";

const COMING_SOON = [
  "Pokémon Booster Boxes",
  "Pokémon Center ETBs",
  "Sports Hobby Boxes",
  "PSA & BGS Graded Cards",
  "Community Trade Nights",
];

export const ComingSoon = ({ variant = "dark" }) => {
  const dark = variant === "dark";
  return (
    <section className={dark ? "bg-[#262626] text-[#F9F6F0]" : "bg-white text-[#262626] border-y border-[#262626]/10"} data-testid="coming-soon-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.2em] text-[#D32F2F]">
            <Sparkles className="w-4 h-4" /> On the Horizon
          </span>
          <h2 className={`mt-3 text-3xl sm:text-4xl font-bold tracking-tight ${dark ? "" : "text-[#262626]"}`}>Coming Soon</h2>
          <p className={`mt-3 ${dark ? "text-[#F9F6F0]/70" : "text-[#262626]/70"}`}>
            We're stocking up and building relationships. Here's what's on the way to Hometown Era Cards.
          </p>
        </div>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="coming-soon-list">
          {COMING_SOON.map((item) => (
            <div
              key={item}
              className={`rounded-lg px-6 py-7 transition-colors hover:border-[#D32F2F] ${
                dark ? "bg-white/5 border border-white/10" : "bg-[#F9F6F0] border border-[#262626]/10"
              }`}
            >
              <Sparkles className="w-6 h-6 text-[#D32F2F]" />
              <h3 className="mt-4 font-display font-bold text-xl">{item}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
